
(() => {
  const selector = '.jdgm-all-reviews-text';
  const destination = '/pages/reviews';

  function setupReviewLinks() {
    document.querySelectorAll(selector).forEach((widget) => {
      if (widget.dataset.reviewLinkReady === 'true') return;

      widget.dataset.reviewLinkReady = 'true';
      widget.setAttribute('role', 'link');
      widget.setAttribute('tabindex', '0');
      widget.setAttribute('aria-label', 'Read all customer reviews');

      widget.addEventListener('click', (event) => {
        if (event.target.closest('a, button')) return;
        window.location.href = destination;
      });

      widget.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          window.location.href = destination;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', setupReviewLinks);
  setupReviewLinks();

  new MutationObserver(setupReviewLinks).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
